import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { ImageWithFallback } from './figma/ImageWithFallback';
import mobileAppScreen from 'figma:asset/b50c4dc45f2b188762bdc690eecadeca7f9927b9.png';
import dashboardScreen from 'figma:asset/1acfafc7f3010a1e70fff666b13b3f251dbc593f.png';

export function HeroSection() {
  const navigate = useNavigate();

  const scrollToLearnMore = () => {
    const element = document.getElementById('players');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-24 pb-16 lg:pt-32 lg:pb-24 bg-gradient-to-br from-background to-accent/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground lowercase leading-tight">
                book. pay. throw.{' '}
                <span className="text-primary">discgo.</span>
              </h1>
              <p className="text-lg sm:text-xl text-muted-foreground max-w-xl">
                the platform connecting disc golf players with private courses. 
                find your next round or manage your course with ease.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => navigate('/login?tab=signup')}
                size="lg"
                className="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-full text-lg transition-all duration-300 hover:shadow-lg hover:shadow-primary/25 transform hover:scale-105"
              >
                sign up
              </Button>
              <Button
                onClick={scrollToLearnMore}
                variant="outline"
                size="lg"
                className="border-2 border-foreground text-foreground hover:bg-foreground hover:text-background px-8 py-3 rounded-full text-lg transition-all duration-300"
              >
                learn more
              </Button>
            </div>
          </div>

          {/* Visual Mockups */}
          <div className="relative">
            <div className="relative z-10 grid grid-cols-5 gap-4 items-center">
              {/* Mobile App Mockup */}
              <div className="col-span-2 transform rotate-3 hover:rotate-0 transition-transform duration-300">
                <div className="bg-white rounded-3xl p-4 shadow-2xl hover:shadow-3xl transition-shadow duration-300">
                  <div className="aspect-[9/19] rounded-2xl overflow-hidden">
                    <img
                      src={mobileAppScreen}
                      alt="Discgo mobile app - Course discovery and booking interface"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* Dashboard Mockup */}
              <div className="col-span-3 transform -rotate-1 hover:rotate-0 transition-transform duration-300">
                <div className="bg-white rounded-2xl p-3 shadow-2xl hover:shadow-3xl transition-shadow duration-300">
                  <div className="aspect-[16/10] rounded-xl overflow-hidden">
                    <img
                      src={dashboardScreen}
                      alt="Discgo Course Manager Dashboard - Overview with bookings, revenue, and pending requests"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Background Elements */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
            <div className="absolute -bottom-8 -left-8 w-24 h-24 bg-accent blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}